import { render, staticRenderFns } from "./delete-modal.html?vue&type=template&id=64198495&scoped=true&external"
import script from "./delete-modal.js?vue&type=script&lang=js&external"
export * from "./delete-modal.js?vue&type=script&lang=js&external"
import style0 from "./delete-modal.scss?vue&type=style&index=0&id=64198495&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64198495",
  null
  
)

export default component.exports